import { useState } from "react";
import { api } from "../../lib/api";

export default function PromoRedeem() {
  const [promo_id, setPromoId] = useState("");
  const [booking_id, setBookingId] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setMsg("");
    setLoading(true);
    try {
      const res = await api.post("/promo-codes/redeem", { promo_id, booking_id });
      setMsg(res.data?.message || "Redeemed");
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || "Redeem failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold">Redeem Promo</h1>
      <p className="text-sm text-gray-600 mt-1">Calls User Redeem API (commit usage).</p>

      <form onSubmit={onSubmit} className="mt-6 border rounded-2xl p-4 space-y-4">
        <div>
          <label className="text-sm font-semibold">Promo ID</label>
          <input className="mt-2 w-full border rounded-xl px-3 py-2" value={promo_id} onChange={(e) => setPromoId(e.target.value)} />
        </div>

        <div>
          <label className="text-sm font-semibold">Booking ID</label>
          <input className="mt-2 w-full border rounded-xl px-3 py-2" value={booking_id} onChange={(e) => setBookingId(e.target.value)} />
        </div>

        {err ? <div className="text-sm text-red-600">{err}</div> : null}
        {msg ? <div className="text-sm text-green-700">{msg}</div> : null}

        <button disabled={loading} className="rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold disabled:opacity-60">
          {loading ? "Redeeming..." : "Redeem"}
        </button>
      </form>
    </div>
  );
}
